class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const autoDelay = 1500;
    const fadeSpeed = 3000;
    const swiperMv = new Swiper('.mv-swiper', {
      slidesPerView: 1,
      loop: true,
      speed: fadeSpeed,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: autoDelay,
        disableOnInteraction: false
      },
      allowTouchMove: false,
      on: {
        slideChangeTransitionStart() {
          const swiper = this;

          const activeBg = document.querySelector('.mv-swiper .swiper-slide-active img');
          if (activeBg) {
            gsap.fromTo(activeBg, { scale: 1 }, {
              scale: 1.1,
              duration: (autoDelay + fadeSpeed) / 1000,
              ease: 'linear'
            });
          }
    
          
          document.querySelectorAll('.mv-swiper .swiper-slide img').forEach(el => {
            if (el !== activeBg) {
              gsap.killTweensOf(el);
              gsap.set(el, { scale: 1.1 });
            }
          });
    
          setTimeout(() => {
            const activeSlide = document.querySelector('.mv-swiper .swiper-slide-active');
            const copy = activeSlide?.getAttribute('data-copy') ?? '';
            const copyTarget = document.getElementById('js-mv-copy-text');
            const wrapper = document.querySelector('.js-mv-copy');
            const subtxt = document.querySelector('.js-mv-subtxt');
    
            if (copyTarget && copy) {
              gsap.to(wrapper, {
                opacity: 0,
                duration: 0.3,
                ease: 'power2.out',
                onComplete: () => {
                  copyTarget.innerHTML = copy;
                  gsap.to(wrapper, { opacity: 1, duration: 0.3, ease: 'power2.out' });
                }
              });
            }
    
            if (subtxt) {
              gsap.to(subtxt, {
                autoAlpha: swiper.realIndex === 0 ? 1 : 0,
                duration: 0.3,
                ease: 'power2.out'
              });
            }
          }, 300);
        }
      }
    });



    const caseSwiper = new Swiper('.case-swiper', { 
      loopAdditionalSlides: 1, 
      slidesPerView: 1.3, 
      spaceBetween: 20, 

    
      breakpoints: { 
        789: { 
          slidesPerView: 3.2,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    
      navigation: {
        nextEl: '.case-swiper-button-next',
        prevEl: '.case-swiper-button-prev',
      },
      on: { 
        init: function () {
          updateCustomCasePager(this);
        },
        slideChange: function () {
          updateCustomCasePager(this);
        },
        progress: function () {
          updateCustomCasePager(this);
        }
      }
    });
    function updateCustomCasePager(swiper) { 
      var progressBar = document.querySelector(".c-swiper-case-line span");
      if (!progressBar) return;
      var totalSlides = swiper.slides.length;
      var slidesPerView = swiper.params.slidesPerView;
      var progress = swiper.progress;
      var initialWidth = (slidesPerView / totalSlides) * 100;
      var progressWidth = initialWidth + (progress * (100 - initialWidth));
      progressBar.style.width = `${progressWidth}%`;
    }
  }
}